import moment from "moment";

const getLast7Days = (): string[] => {
  return [...Array(8)].map((_, i) => 
    moment().subtract(7 - i, "days").format("ddd") // Start from 7 days ago, include today
  );
};

export default getLast7Days;
